import { _ as _slicedToArray } from './text-b8c251ed.esm.js';
export { c as buttonColor, e as buttonEqualSizes, f as buttonFill, a as buttonShape, b as buttonShapeEqual, d as buttonSize, h as buttonSizes, p as buttonVariant, i as checkboxSize, i as controlSize, t as headingCapsizes, r as headingPresets, j as headingSize, q as headingSizes, c as iconButtonColor, f as iconButtonFill, b as iconButtonShape, d as iconButtonSize, s as iconSize, l as iconSizes, k as listSize, l as loaderSizes, m as progressSize, v as progressVariant, i as radioSize, i as sliderSize, n as tabSize, x as textCapsizes, w as textPresets, o as textSize, u as textSizes } from './text-b8c251ed.esm.js';
import { b as borderWidths, n as neutralHues, d as palettes, h as hues, s as schemes, e as brandSchemes, f as neutralSchemes } from './shadows-2f16f0de.esm.js';
export { p as borderPreset, a as borderPresets, w as borderWidthPresets, b as borderWidths, c as breakpoints, h as colorHues, n as colorHuesNeutral, d as colorPalettes, s as colorSchemes, e as colorSchemesBrand, f as colorSchemesNeutral, g as colorSchemesProduct, j as colors, m as motion, o as shadowHalo, k as shadowHalos, q as shadowInvisible, l as shadowRing, r as shadowRings, i as shadows } from './shadows-2f16f0de.esm.js';
import { s as space } from './typography-2ccf363f.esm.js';
export { r as radii, a as sizes, s as space, t as typography } from './typography-2ccf363f.esm.js';
import _curry from 'ramda/src/curry';
import { math, lighten, darken, transparentize } from 'polished';
import '@hover/tokens-device';
import * as tokens from '@hover/tokens-color';
export { tokens as colorTokens };
import 'ramda/src/map';
import '@hover/tokens-motion';
import '@hover/tokens-border';
import '@hover/tokens-depth';
import '@hover/tokens-size';
import '@hover/tokens-size/next';
import { split, includes, assertUnreachable } from '@hover/utilities';
import '@hover/tokens-typography';
import '@hover/tokens-space';
import './unsupportedIterableToArray-d4b21e24.esm.js';
import 'ramda/src/pick';
import '@hover/tokens-typography/assets/capsizes.json';

var spaceForBorderWidth = /*#__PURE__*/_curry(function (width, space$1) {
  return math("".concat(space[space$1], " - ").concat(borderWidths[width]));
});

/**
 * Type guard for `Color` type
 */
var isColor = function isColor(color) {
  if (!color.includes('.')) return false;
  var _split = split(color, '.'),
    _split2 = _slicedToArray(_split, 2),
    palette = _split2[0],
    hue = _split2[1];
  if (palette === 'neutral' && includes(neutralHues.map(function (h) {
    return h.toString();
  }), hue)) return true;
  if (includes(palettes, palette) && includes(hues.map(function (h) {
    return h.toString();
  }), hue)) return true;
  return false;
};

/**
 * Type guard for `ColorScheme` type
 */
var isColorScheme = function isColorScheme(colorScheme) {
  return includes(schemes, colorScheme);
};

/**
 * Type guard for `ColorSchemeBrand` type
 */
var isBrandColorScheme = function isBrandColorScheme(colorScheme) {
  return includes(brandSchemes, colorScheme);
};

/**
 * Type guard for `ColorScheme` type
 */
var isNeutralScheme = function isNeutralScheme(colorScheme) {
  return includes(neutralSchemes, colorScheme);
};

/**
 * Color palettes with consistent scales
 * - Base color is `color.500`
 * - Scale goes from 50 to 900
 */
var normalPalettes = ['success', 'warning', 'danger', 'brandBrown', 'brandGreen', 'brandNavy', 'brandYellow', 'brandTan', 'brandOrange', 'brandRed'];

/**
 * Provide a default color scheme to convert `string` to `ColorScheme`
 *
 * @param colorScheme maybe color scheme value
 * @param defaultColorScheme fallback color scheme
 */
var colorSchemeWithDefault = function colorSchemeWithDefault(colorScheme, defaultColorScheme) {
  return colorScheme && isColorScheme(colorScheme) ? colorScheme : defaultColorScheme;
};

/**
 * Default unknown color scheme to neutral to convert `string` to `ColorScheme`
 *
 * @param colorScheme maybe color scheme
 */
var colorSchemeOrNeutral = function colorSchemeOrNeutral(colorScheme) {
  return colorSchemeWithDefault(colorScheme, 'neutral');
};
var colorHelpersFor = function colorHelpersFor(colors) {
  /**
   * Get styles for high-contrast foreground and
   * background colors for a given color scheme
   *
   * @param colorScheme color scheme from theme
   * @returns
   */
  var colorFor = function colorFor(colorScheme) {
    switch (colorScheme) {
      case 'primary':
        return {
          backgroundColor: 'primary.600',
          color: 'neutral.0'
        };
      case 'success':
        return {
          backgroundColor: 'success.500',
          color: 'neutral.0'
        };
      case 'warning':
        return {
          backgroundColor: 'warning.500',
          color: 'neutral.700'
        };
      case 'danger':
        return {
          backgroundColor: 'danger.500',
          color: 'neutral.0'
        };
      default:
        return {
          backgroundColor: 'neutral.600',
          color: 'neutral.0'
        };
    }
  };
  var defaultSoftColor = {
    backgroundColor: 'neutral.100',
    // TODO: replace with a new neutral token at some point?
    color: lighten(0.1, colors.neutral[700])
  };
  var defaultSoftColorDark = {
    backgroundColor: 'neutral.300',
    color: 'neutral.700'
  };
  var getSoftColor = function getSoftColor(colorScheme) {
    var dark = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var background = dark ? 200 : 100;
    switch (colorScheme) {
      case 'primary':
      case 'secondary':
        // Deprecated
        return {
          backgroundColor: "primary.".concat(background),
          color: "primary.".concat(dark ? 700 : 600)
        };
      case 'success':
        return {
          backgroundColor: "success.".concat(background),
          color: "success.".concat(dark ? 600 : 500)
        };
      case 'warning':
        return {
          backgroundColor: "warning.".concat(background),
          color: "warning.".concat(dark ? 700 : 600)
        };
      case 'danger':
        return {
          backgroundColor: "danger.".concat(background),
          color: "danger.".concat(dark ? 600 : 500)
        };
      case 'neutral':
        return dark ? defaultSoftColorDark : defaultSoftColor;
      default:
        return assertUnreachable(colorScheme);
    }
  };

  /**
   * Get styles for soft contrast (e.g: dark red on red) foreground
   * and background colors for a given _brand_ color scheme
   *
   * @param colorScheme color scheme from theme
   * @param dark whether to return slightly darker color combination
   */
  var softBrandColorFor = function softBrandColorFor(colorScheme) {
    var dark = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var background = dark ? 200 : 100;
    switch (colorScheme) {
      case 'brandYellow':
        return {
          backgroundColor: "brandYellow.".concat(background),
          color: "brandYellow.".concat(dark ? 800 : 700)
        };
      case 'brandTan':
        return {
          backgroundColor: "brandTan.".concat(dark ? 400 : 200),
          color: "brandTan.".concat(dark ? 900 : 800)
        };
      case 'brandGreen':
      case 'brandBrown':
      case 'brandRed':
      case 'brandNavy':
      case 'brandOrange':
        return {
          backgroundColor: "".concat(colorScheme, ".").concat(background),
          color: "".concat(colorScheme, ".").concat(dark ? 600 : 500)
        };
      default:
        return assertUnreachable(colorScheme);
    }
  };

  /**
   * Get styles for soft contrast (e.g: dark red on red) foreground
   * and background colors for a given brand or product color scheme
   *
   * @param colorScheme color scheme from theme
   * @returns
   */
  var softColorFor = function softColorFor(colorScheme) {
    var dark = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (isColorScheme(colorScheme) && !isNeutralScheme(colorScheme)) {
      return isBrandColorScheme(colorScheme) ? softBrandColorFor(colorScheme, dark) : getSoftColor(colorScheme, dark);
    }
    return dark ? defaultSoftColorDark : defaultSoftColor;
  };
  var primary = colors.primary,
    neutral = colors.neutral,
    lightAlpha = colors.lightAlpha;
  var neutral625 = darken(0.1, neutral['600']);
  var neutral650 = darken(0.2, neutral['600']);
  var getStateColors = function getStateColors(colorScheme) {
    var raw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!isColorScheme(colorScheme) || includes(['secondary', 'neutral', 'dark'], colorScheme)) {
      // Default to neutral
      return {
        idle: raw ? neutral['600'] : 'neutral.600',
        hover: neutral625,
        active: neutral650,
        hoverBackground: raw ? neutral[100] : 'neutral.100',
        activeBackground: raw ? neutral[200] : 'neutral.200'
      };
    }
    if (colorScheme === 'light') {
      return {
        idle: raw ? neutral[0] : 'neutral.0',
        hover: raw ? neutral[200] : 'neutral.200',
        active: raw ? neutral[300] : 'neutral.300',
        hoverBackground: raw ? lightAlpha[200] : 'lightAlpha.200',
        activeBackground: raw ? lightAlpha[300] : 'lightAlpha.300'
      };
    }

    // Primary is weird, base is 600 instead of 500
    if (colorScheme === 'primary') {
      return {
        idle: raw ? primary.base : 'primary.base',
        hover: raw ? primary[700] : 'primary.700',
        active: raw ? primary[800] : 'primary.800',
        hoverBackground: raw ? primary[100] : 'primary.100',
        activeBackground: raw ? primary[200] : 'primary.200'
      };
    }

    // Everything else is base 500
    if (includes(normalPalettes, colorScheme)) {
      var palette = colors[colorScheme];
      return {
        idle: raw ? palette[500] : "".concat(colorScheme, ".500"),
        hover: raw ? palette[600] : "".concat(colorScheme, ".600"),
        active: raw ? palette[700] : "".concat(colorScheme, ".700"),
        hoverBackground: raw ? palette[100] : "".concat(colorScheme, ".100"),
        activeBackground: raw ? palette[200] : "".concat(colorScheme, ".200")
      };
    }
    return assertUnreachable(colorScheme);
  };

  /**
   * Get the hex color value for a color token
   *
   * @param color color token
   *
   * @returns hex value of color
   */
  var colorValueFor = function colorValueFor(color) {
    if (color === 'neutral.0') return colors.neutral[0];
    var _split = split(color, '.'),
      _split2 = _slicedToArray(_split, 2),
      palette = _split2[0],
      hue = _split2[1];
    if (isBrandColorScheme(palette) || palette === 'secondary') {
      return colors[palette][hue === '50' ? '100' : hue];
    }
    return colors[palette][hue];
  };

  /**
   * Helper for applying transparency to a given color. Supports both system
   * color tokens and raw color values.
   *
   * @example
   * ```ts
   * // Token
   * alpha(0.25, 'primary.700')
   * // Raw
   * alpha(0.25, '#dc8a78')
   * ```
   *
   * @param amount percentage transparency in decimal form
   * @param color color token or value
   * @returns
   */
  var alpha = function alpha(amount, color) {
    return transparentize(amount, isColor(color) ? colorValueFor(color) : color);
  };
  return {
    alpha: alpha,
    colorFor: colorFor,
    colorValueFor: colorValueFor,
    getStateColors: getStateColors,
    softColorFor: softColorFor
  };
};

export { colorHelpersFor, colorSchemeOrNeutral, colorSchemeWithDefault, isBrandColorScheme, isColor, isColorScheme, isNeutralScheme, normalPalettes, spaceForBorderWidth };
